import { render, staticRenderFns } from "./QuickList.vue?vue&type=template&id=2f8afca0&scoped=true&"
import script from "./QuickList.vue?vue&type=script&lang=js&"
export * from "./QuickList.vue?vue&type=script&lang=js&"
import style0 from "./QuickList.vue?vue&type=style&index=0&id=2f8afca0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8afca0",
  null
  
)

export default component.exports